import React from 'react';

import { SideNav, SideNavItems, HeaderSideNavItems } from '@carbon/react';

class CustomSideNav extends React.Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      this.props.leftSideNavVisible
    ) {
      this.props.hide();
    }
  }

  render() {
    const { children, leftSideNavVisible } = this.props;

    return (
      <SideNav
        ref={this.setWrapperRef}
        aria-label="Side Navigation"
        expanded={leftSideNavVisible}
        defaultExpanded={false}
        isChildOfHeader={true}
        isFixedNav={true}
        isPersistent={false}>
        <SideNavItems>
          <HeaderSideNavItems>{children}</HeaderSideNavItems>
        </SideNavItems>
      </SideNav>
    );
  }
}

export default CustomSideNav;
